import type { TabProps, TabPaneProps } from '@sgui-plus/components/tab'
import type {
  ComponentInternalInstance,
  ComputedRef,
  Ref,
  InjectionKey,
  UnwrapRef,
  ShallowReactive,
} from 'vue'

export type TabPaneContext = UnwrapRef<{
  uid: number
  instance: ShallowReactive<ComponentInternalInstance>
  props: TabPaneProps
  paneName: ComputedRef<string | undefined>
  active: ComputedRef<boolean>
  index: Ref<string | undefined>
  isClosable: ComputedRef<boolean>
}>

export interface TabRootContext {
  props: TabProps
  currentName: Ref<string | number>
  updatePaneState: (pane: TabPaneContext) => void
}

export const TabRootContextKey: InjectionKey<TabRootContext> = Symbol('TabRootContextKey')
